import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':accountId'}/resendPhoneInvite`;

export const ROUTE: RouteDefinition = `${baseRoute}/:accountId/resendPhoneInvite`;

export const URL = (accountId: number): RouteDefinition => `${baseRoute}/${accountId}/resendPhoneInvite`;
